import React from 'react';
import { CARD } from '../ui';
import { DATA_HUE, TRACK, formatCount } from './theme';

// A ranked bar list. One series, so one color for every bar — length carries
// the comparison. Values are always printed beside the bar, so nothing is
// reachable only by hovering.
const BarList = ({ title, subtitle, items, emptyLabel, footer, onSelect }) => {
  const max = Math.max(1, ...items.map((item) => item.value));

  return (
    <div className={`${CARD} p-6`}>
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-white">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>

      {items.length === 0 ? (
        <p className="text-sm text-gray-500 py-6 text-center">{emptyLabel}</p>
      ) : (
        <ul className="space-y-4">
          {items.map((item) => {
            const row = (
              <>
                <div className="flex items-baseline justify-between gap-3">
                  <span className="text-sm text-gray-300 truncate">{item.label}</span>
                  <span className="text-sm font-semibold text-white tabular-nums flex-shrink-0">
                    {formatCount(item.value)}
                  </span>
                </div>
                <div className="mt-2 h-2 rounded-sm overflow-hidden" style={{ backgroundColor: TRACK }}>
                  <div
                    className="h-full"
                    style={{
                      width: `${(item.value / max) * 100}%`,
                      backgroundColor: DATA_HUE,
                      borderRadius: '0 4px 4px 0',
                    }}
                  />
                </div>
                {item.meta && <p className="mt-1 text-xs text-gray-500 truncate">{item.meta}</p>}
              </>
            );
            return (
              <li key={item.key}>
                {onSelect ? (
                  <button
                    type="button"
                    onClick={() => onSelect(item)}
                    // hover:bg-transparent is load-bearing: App.css's global
                    // `button:hover` background would otherwise win here.
                    className="w-full text-left bg-transparent hover:bg-transparent p-0 rounded-lg hover:opacity-80 transition-opacity duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
                  >
                    {row}
                  </button>
                ) : (
                  row
                )}
              </li>
            );
          })}
        </ul>
      )}

      {footer && <div className="mt-5 pt-4 border-t border-gray-700/60 text-sm text-gray-500">{footer}</div>}
    </div>
  );
};

export default BarList;
